import React from 'react';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import type { ArticlesQuery, ArticlesQueryVariables, PagesQuery } from '../../graphql/generated/schema';
import { ArticlesScrollerClient } from './index.client';
import { cmsClient } from '../../graphql';
import { ARTICLES } from '../../graphql/query/article';

export const ArticlesScroller: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'ArticlesScroller'>> = async (props) => {
  const { method, articles, categories, tags } = props;

  const { Articles } = await cmsClient.request<ArticlesQuery, ArticlesQueryVariables>(ARTICLES, {
    limit: 10,
    page: 1,
    sort: '-createdAt',
    ...(method === 'manual' || (categories?.length || tags?.length) ? {
      where: {
        ...(method === 'manual' ? {
          id: {
            in: articles?.map(({ id }) => id) || [],
          },
        } : {}),
        ...(method === 'latest' && categories?.length ? {
          categories: {
            in: categories.map(({ id }) => id),
          },
        } : {}),
        ...(method === 'latest' && tags?.length ? {
          tags: {
            in: tags.map(({ id }) => id),
          },
        } : {}),
      },
    } : {}),
  });

  return (
    <ArticlesScrollerClient
      {...props}
      articleDocs={Articles}
    />
  );
};
